export const projects = [
  {
    id: "project-1",
    title: "Interactive Artwork Ex.",
    component: () => import("../pages/Project1/Project1"),
  },
  {
    id: "project-2",
    title: "Techenical Analysis demo",
    component: () => import("../pages/Project2/Project2"),
  },
];
